import "./_style.scss";
import { useContext, useEffect, useState, useRef } from "react";
import { fakeTableList, schema } from "./parts";
import { httpAPI_RET006 } from "./api/request";
import TkFakeTable from "../../components/molecules/TkFakeTable";
import { useLocation, useNavigate } from "react-router-dom";
import TkBackButton from "../../components/molecules/TkBackButton";
import { Box } from "@mui/material";
import { BusinessContext } from "../../context/businessContext";
import { GlobalContext } from "../../context/globalContext";
import _ from "lodash";

/**
 * SCRW410030 退職手当金の請求手続き(振込状況の確認)
 * @return SCRW410030 退職手当金の請求手続き(振込状況の確認)
 */
const SCRW410030 = () => {
  const navigate = useNavigate();
  const location = useLocation();
  let locationState = location.state;
  const { state: globalState, setState: setGlobalState } =
    useContext(GlobalContext);
  const { state } = useContext(BusinessContext);
  const [infoTableList, setInfoTableList] = useState<any>([]);
  const infoTableListRef = useRef(_.cloneDeep(fakeTableList));

  async function openingScrren() {
    try {
      const res = await httpAPI_RET006({
        applyId: locationState?.applyId,
      });
      let resArr = infoTableListRef.current;

      if (res.resultCd === "I0000") {
        resArr.find(
          (item) => item.keyword === "contractorName"
        )!.contractorNumber =
          state.common?.contractorNo + ":" + state.common?.contractorName;

        const retirementInvoiceReceptionDay = new Date(
          res.retirementInvoiceReceptionDay!
        );
        const staffName = resArr.find((item) => item.keyword === "staffName")!;
        staffName.text = res.staffName;

        resArr.find(
          (item) => item.keyword === "retirementInvoiceReceptionDay"
        )!.text =
          (isNaN(retirementInvoiceReceptionDay.getFullYear())
            ? ""
            : retirementInvoiceReceptionDay.getFullYear()) +
          "年" +
          (isNaN(retirementInvoiceReceptionDay.getMonth())
            ? ""
            : retirementInvoiceReceptionDay.getMonth() + 1) +
          "月" +
          (isNaN(retirementInvoiceReceptionDay.getDate())
            ? ""
            : retirementInvoiceReceptionDay.getDate()) +
          "日";

        const maePeriod = resArr.find((item) => item.keyword === "maePeriod")!;
        maePeriod.text = res.maePeriod;

        resArr.find((item) => item.keyword === "reason")!.setDefaultValue =
          res.reason;

        setInfoTableList([...resArr]);
        setGlobalState({
          ...globalState,
          errorMsgId: "",
        });
      } else {
        setGlobalState({
          ...globalState,
          errorMsgId: res.resultCd,
        });
      }
    } catch (error) {
      navigate("/error");
    }
  }

  useEffect(() => {
    openingScrren();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Box data-testid="SCRW410030PageForTest" className="tkSCRW410030">
      <TkFakeTable
        list={infoTableList}
        ruleSchema={schema}
        disabled={true}
        showButton={false}
      />
      <Box className="tkDisplay">
        <TkBackButton />
      </Box>
    </Box>
  );
};

export default SCRW410030;
